export const PHASE = "prod";
export const API_LOCAL = "http://localhost:8021/api/v3";
export const API = "https://care-verification.care.services.khoros.com/api/v3";